export const setMetaTag = (selector: string, content: string) => {
  let meta = document.querySelector(selector)
  if (meta) {
    meta.setAttribute('content', content)
  } else {
    meta = document.createElement('meta')
    if (selector.includes('property')) {
      const property = selector.match(/property="([^"]+)"/)?.[1]
      if (property) {
        meta.setAttribute('property', property)
      }
    } else if (selector.includes('name')) {
      const name = selector.match(/name="([^"]+)"/)?.[1]
      if (name) {
        meta.setAttribute('name', name)
      }
    }
    meta.setAttribute('content', content)
    document.head.appendChild(meta)
  }
}
